export interface Location {
  LocationId: number | null;
  Name: string;
  LocationDirectionType: string;
  AddFillingType: string;
  AddGrouped: boolean;
  RemoveFillingType: string;
  MergeConsecutiveGroups: boolean;
  MaxProductsCount: number;
  LayoutOrder: number;
  ClearEnabled: boolean;
  ClearRequiredUserRole: string;
  MaxProductsDisplayCount: number;
  ShowTensileEstimation: boolean;
  IsEnable?: boolean;
}

export const LOCATION_INITIAL_VALUES: Location = {
  LocationId: null,
  Name: "",
  LocationDirectionType: "B",
  AddFillingType: "F",
  AddGrouped: false,
  RemoveFillingType: "F",
  MergeConsecutiveGroups: true,
  MaxProductsCount: -1,
  LayoutOrder: -1,
  ClearEnabled: false,
  ClearRequiredUserRole: "",
  MaxProductsDisplayCount: -1,
  ShowTensileEstimation: false,
  IsEnable: true,
};
